/**
 * TanStack Query hooks for `ipqs`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	ipqsQueryKeys,
	type CreateIpqsBody,
	type ListIpqsResponse,
	type IpqsRow,
} from "./api";

export function useIpqsList(): UseQueryResult<ListIpqsResponse, Error> {
	return useQuery({
		queryKey: ipqsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIpqsCreate(): UseMutationResult<IpqsRow, Error, CreateIpqsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ipqsQueryKeys.all });
		},
	});
}

export function useIpqsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ipqsQueryKeys.all });
		},
	});
}
